import React from 'react';

import { NewEmployeeGlidepath } from './NewEmployeeGlidepath';
import './metricGuidline.scss';

export const AgentGuidline = () => {
    return (
        <>
            <ul>
                <li>
                    The current P4P program is based on individual associate performance.  There is no longer
                    a stack ranking with just the top 25% achieving a <br />
                    pay-out. EVERY associate that meets the required program metrics will earn a pay-out
                    providing they meet the qualifiers listed below. 
                </li>
                <li>In order to achieve a payout, employees must first meet the following qualifiers:</li>
                <li>
                    Employee must have at least 80 worked hours in production to be eligible for payout on
                    program scorecard.
                </li>
                <li>Employee must not be on a 2nd level written corrective action or higher.</li>
                <li>
                    Tenure will be based on overall company tenure to ensure employees are not penalized if
                    moved to a new program.  The P4P program aims <br />
                    to honor employees commitment to TTEC.  Payout percents increase at each TTEC tenure
                    threshold:  0-6 months, 6-12 months, and 12+ months.
                </li>
                <li>
                    Employees with less than 3 months tenure on a program will have pro-rated metric targets
                    based on glidepath below.
                </li>
                <li>
                    Tenure will be based program tenure vs. company tenure to ensure those still learning a
                    new client program are given a fair chance to realize <br /> rewards.
                </li>
            </ul>
            <div className="employee-glidepath">
                <NewEmployeeGlidepath />
            </div>
            <ul>
                <li>
                    If there is no data available for a particular metric, that metric will be removed from
                    your P4P requirements for the month. In the example of not <br />
                    receiving any CSAT surveys, your payout will be recalibrated and as long as you achieve
                    the remaining 4 metrics you will be paid out as if you <br />
                    achieved 5 out of 5 metrics. If you achieve 3 metrics you will be paid out as if you had
                    achieved 4 out of 5 metrics for the month. There must <br />
                    be data available for at least 3 metrics in order to be eligible for award.
                </li>
                <li>
                    Payouts will vary by region but are generally the next regular pay cycle from 45 days
                    after the close of the month. Please consult your P4P Plan <br />
                    Design document in TTEC Talent for more information.
                </li>
            </ul>
        </>
    );
};
